import { Alert, AlertProps } from "@mui/material";
import Iconify from "components/iconify";

export default function AlertNotification(props: AlertProps) {

  return (
    <Alert
      iconMapping={{
        success: <Iconify icon="mdi:check-circle" fontSize="inherit" />,
        error: <Iconify icon="mdi:alert-octagon" fontSize="inherit" />,
        warning: <Iconify icon="mdi:alert" fontSize="inherit" />,
        info: <Iconify icon="mdi:information" fontSize="inherit" />,
      }}
      {...props}
    >
      {props.children}
    </Alert>
  );
}
